import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-breadcrumbs',
  template: `
    <div class="rcp-breadcrumbs">
      <ng-content></ng-content>
    </div>
  `,
  styles: `
    :host {
      display: block;
    }

    .rcp-breadcrumbs {
      display: flex;
      gap: var(--spacing-sm);
      font-size: var(--font-size-small);
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BreadCrumbsComponent {}
